import {useEffect, useState} from 'react';
import moment from 'moment';
import {calculateMaxRepeatEndDate} from '@services/calendar/availability.service';

type UseRepeatEndDateProps = {
    repeatType: string | undefined;
    startTime: string | undefined;
    watch: (name: string) => any;
    setValue: (name: string, value: any, options?: any) => void;
};

export const useRepeatEndDate = ({repeatType, startTime, watch, setValue}: UseRepeatEndDateProps) => {
    const [maxRepeatEndDate, setMaxRepeatEndDate] = useState<string | undefined>();

    useEffect(() => {
        if (repeatType && repeatType !== 'DONT_REPEAT' && startTime) {
            const maxDate = calculateMaxRepeatEndDate(startTime);
            setMaxRepeatEndDate(maxDate);

            const currentVal = watch('repeatEndDate');
            if (!currentVal || moment(currentVal).isAfter(moment(maxDate))) {
                setValue('repeatEndDate', maxDate, {shouldDirty: false});
            }
        }
    }, [repeatType, startTime, setValue, watch]);

    return maxRepeatEndDate;
};
